import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { CancelRounded } from '@mui/icons-material';
import myFunctions from '../myFunctions';

const PopUpCreditsUse = (props) => {
    const { userCredits, maxCredits, orderTotal, initialSelected, onUse, onSkip, handleClose } = props;

    const [selected, setSelected] = useState(
        initialSelected > 0 ? Math.min(initialSelected, maxCredits) : maxCredits
    );

    const remaining = Math.max(0, orderTotal - selected);

    const handleChange = (val) => {
        const num = Math.min(Math.max(1, parseInt(val) || 1), maxCredits);
        setSelected(num);
    };

    const closeIt = () => {
        if (typeof handleClose === 'function') handleClose();
    };

    myFunctions.useEscapeKey(closeIt);

    return (
        <Dialog open={true} className={"popDiagBlock creditsPopCard centerPop"}>
            <button type="button" className={"btnReset closePopWinBtn fullRow"} aria-label="סגור" onClick={closeIt}>
                <CancelRounded className={"inBlack popUpCloseBtn_Small pointing"} aria-hidden="true" />
            </button>
            <DialogTitle className={"theTitlePop_1 headOnFixPop"}>
                יש לך <strong>{userCredits} </strong>קרדיטים לשימוש!
            </DialogTitle>
            <DialogContent>
                <div className={"creditsPopContent"}>
                    {/* <div className={"creditsPopBalance"}>
                        יתרת קרדיטים: <strong>{userCredits} ₪</strong>
                    </div> */}
                    <div className={"creditsPopRow spaceMargeTopbig"}>
                        <label className={"bold"} htmlFor="creditsUseInput">בכמה להשתמש?</label>
                        <div className={"creditsPopInputRow spaceMargeTopbig centerText"}>
                            <input
                                id="creditsUseInput"
                                type="number"
                                className={"roundedInputTxt creditsPopInput"}
                                min={1}
                                max={maxCredits}
                                value={selected}
                                onChange={(e) => handleChange(e.target.value)}
                            />
                            <span className={"spaceRightLongi"}>מתוך {maxCredits} ₪</span>
                        </div>
                    </div>
                    <div className={"creditsPopSummary spaceMargeTopbig"}>
                        <div className={"creditsPopLine"}>
                            <span>קרדיטים:</span>
                            <span className={"inGreen bold"}>-{selected} ₪</span>
                        </div>
                        <div className={"creditsPopLine bold"}>
                            <span>לתשלום:</span>
                            <span>{remaining.toFixed(2)} ₪</span>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <button
                    type="button"
                    className={"centerMe btn btnPopRegular blueBtn whiteText pointing"}
                    onClick={() => onUse(selected)}
                >
                    השתמש ב-{selected} קרדיטים
                </button>
            </DialogActions>
            <DialogActions>
                <button
                    type="button"
                    className={"btn-success btnPopRegular TokenChargeBtn btnPopRegularSec spaceTopBig pointing"}
                    onClick={() => onSkip()}
                >
                    דלג, אל תשתמש בקרדיטים
                </button>
            </DialogActions>
        </Dialog>
    );
};

export default PopUpCreditsUse;
